import MultimediaGrid from '../../../../multimedia-grid/clientlibs/site/js/multimedia-grid.js';
import { useEffect } from 'preact/hooks';

function MultimediaGridComponent({ componentName, images, brandIcon, brandIconOverride, i18n }: {
    componentName: string;
    images: {
        url: string;
        alt: string;
    }[];
    brandIcon: string | null;
    brandIconOverride: string | null;
    i18n: (key: string) => string;
}) {
    useEffect(() => {
        const multimediaGridElement = document.querySelector(`.${componentName} .multimedia-grid`);
        if (multimediaGridElement && multimediaGridElement.classList.contains('carousel')) {
            new MultimediaGrid(multimediaGridElement).init();
        }
    }, []);

    return (
        <div class="multimedia-grid carousel">
            <div class="multimedia-grid__container" aria-roledescription="multimedia-grid">
                {/* Thumbnail Track */}
                <div class="multimedia-grid__thumbnail-track glide">
                    <button class="multimedia-grid__previous">
                        <span class="prev-arrow raw-file-contents" aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" aria-labelledby="chevronUpTitle chevronUpDesc" role="img">
                                <title id="chevronUpTitle">{i18n('Chevron Up')}</title>
                                <desc id="chevronUpDesc">{i18n('Chevron Up')}</desc>
                                <path d="M7.514 19.554l8.88-5.474 8.063 5.455a.8.8 0 1 0 .897-1.325l-8.491-5.745a.799.799 0 0 0-.868-.018l-9.32 5.745a.8.8 0 0 0 .839 1.362z"></path>
                            </svg>
                        </span>
                    </button>
                    <div class="glide__track" data-glide-el="track">
                        <ul class="multimedia-grid__thumbnail-list glide__slides">
                            {images.map((image, index) => (
                                <li class="multimedia-grid__thumbnail glide__slide" data-slide={`slide${index}`}>
                                    <div class="multimedia-slide parbase">
                                        <div class="parbase-inner">
                                            <picture>
                                                <img
                                                    class="main-image"
                                                    data-ot-ignore=""
                                                    src={image.url}
                                                    alt={image.alt}
                                                />
                                            </picture>
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <button class="multimedia-grid__next">
                        <span class="next-arrow raw-file-contents" aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" aria-hidden="true" focusable="false">
                                <path d="M24.486 12.447l-8.88 5.474-8.063-5.456a.8.8 0 1 0-.897 1.325l8.491 5.745c.261.176.6.184.868.018l9.32-5.745a.8.8 0 1 0-.839-1.36z"></path>
                            </svg>
                        </span>
                    </button>
                    <div class="glide__bullets" data-glide-el="controls[nav]">
                        {images.map((image, index) => (
                            <button class="glide__bullet" data-glide-dir={`=${index}`}></button>
                        ))}
                    </div>
                </div>

                {/* Active Media */}
                <div class="multimedia-grid__active-media" id="slide0">
                    <div class="multimedia-slide parbase">
                        <div class="parbase-inner">
                            <picture>
                                <img
                                    class="main-image"
                                    data-ot-ignore=""
                                    src={images[0].url}
                                    alt={images[0].alt}
                                />
                            </picture>
                        </div>
                    </div>
                </div>

                {/* Gallery Modal */}
                <div class="multimedia-grid__gallery-modal" data-arrows-bound="true">
                    <div class="multimedia-grid__gallery-modal-background"></div>
                    <div class="multimedia-grid__gallery-modal-container">
                        <div class="multimedia-grid__gallery-modal-main">
                            <div class="multimedia-grid__gallery-modal-main-arrow" data-direction="prev" tabIndex={0}>
                                <span class="raw-file-contents" aria-hidden="true">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" aria-labelledby="chevronLeftTitle chevronLeftDesc" role="img">
                                        <title id="chevronLeftTitle">{i18n('Chevron Left')}</title>
                                        <desc id="chevronLeftDesc">{i18n('Chevron Left')}</desc>
                                        <path d="M14.08 15.606l5.455-8.063a.8.8 0 1 0-1.325-.897l-5.745 8.491a.799.799 0 0 0-.018.868l5.745 9.32a.8.8 0 1 0 1.362-.84l-5.474-8.879z"></path>
                                    </svg>
                                </span>
                            </div>
                            <div class="multimedia-grid__gallery-modal-frame active">
                                <img
                                    class="multimedia-grid__gallery-modal-image multimedia-grid__gallery-modal-image--zoomed-out multimedia-grid__product-image"
                                    src={images[0].url}
                                    alt={images[0].alt}
                                />
                            </div>
                            <div class="multimedia-grid__gallery-modal-main-arrow" data-direction="next" tabIndex={0}>
                                <span class="raw-file-contents" aria-hidden="true">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" aria-hidden="true">
                                        <path d="M12.446 7.514l5.474 8.88-5.455 8.063a.8.8 0 1 0 1.325.897l5.745-8.491a.799.799 0 0 0 .018-.868l-5.745-9.32a.8.8 0 0 0-1.362.839z"></path>
                                    </svg>
                                </span>
                            </div>
                        </div>
                        <div class="multimedia-grid__gallery-modal-list">
                            <div class="multimedia-grid__gallery-modal-list-arrow" data-direction="prev" tabIndex={0}>
                                <span class="raw-file-contents" aria-hidden="true">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" aria-labelledby="chevronLeftTitle chevronLeftDesc" role="img">
                                        <title id="chevronLeftTitle">{i18n('Chevron Left')}</title>
                                        <desc id="chevronLeftDesc">{i18n('Chevron Left')}</desc>
                                        <path d="M14.08 15.606l5.455-8.063a.8.8 0 1 0-1.325-.897l-5.745 8.491a.799.799 0 0 0-.018.868l5.745 9.32a.8.8 0 1 0 1.362-.84l-5.474-8.879z"></path>
                                    </svg>
                                </span>
                            </div>
                            <div class="multimedia-grid__gallery-modal-list-container">
                                <div class="multimedia-grid__gallery-modal-list-frame active" tabIndex={0}>
                                    <img
                                        class="multimedia-grid__gallery-modal-list-image multimedia-grid__product-image"
                                        src={images[0].url}
                                        alt={images[0].alt}
                                    />
                                </div>
                            </div>
                            <div class="multimedia-grid__gallery-modal-list-arrow" data-direction="next" tabIndex={0}>
                                <span class="raw-file-contents" aria-hidden="true">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" aria-hidden="true">
                                        <path d="M12.446 7.514l5.474 8.88-5.455 8.063a.8.8 0 1 0 1.325.897l5.745-8.491a.799.799 0 0 0 .018-.868l-5.745-9.32a.8.8 0 0 0-1.362.839z"></path>
                                    </svg>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {(brandIcon || brandIconOverride) && (
                <div className={`${componentName}__brand-logo-container`}>
                    <img className={`${componentName}__brand-logo`} src={brandIconOverride || `/etc.clientlibs/rockwell-aem-base/clientlibs/clientlib-base/resources/icons/${brandIcon}`}></img>
                </div>
            )}
        </div>  
    );
}

export default MultimediaGridComponent;